import { Feature, getUid } from "ol";
import GeoJSON from "ol/format/GeoJSON.js";
import { Point } from "ol/geom.js";
import VectorLayer from "ol/layer/Vector.js";
import { fromLonLat } from "ol/proj.js";
import VectorSource from "ol/source/Vector.js";
import { Fill, RegularShape, Stroke, Style } from "ol/style.js";
import { capaActiva } from "../capaActiva/index.js";
import Punto from "../controls/botonDibujoPunto.js";

function crearCapaPuntos() {
  const source = new VectorSource({ wrapX: false });
  const vector = new VectorLayer({
    source,
    style: new Style({
      image: new RegularShape({
        fill: new Fill({ color: "red" }),
        stroke: new Stroke({ color: "black", width: 2 }),
        points: 3,
        radius: 10,
        rotation: Math.PI / 3,
        angle: 0,
      }),
    }),
  });

  return { source, vector };
}

function descargarCapa(source) {
  const format = new GeoJSON({ featureProjection: "EPSG:3857" });
  const features = source.getFeatures();
  const json = format.writeFeatures(features);

  const blob = new Blob([json], {
    type: "application/json;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "capa_activa.geojson";
  link.click();
}

export function configurarPuntosUsuario(map, onActivate) {
  const latInput = document.getElementById("lat-input");
  const lonInput = document.getElementById("lon-input");
  const searchButton = document.getElementById("ir-a-lat-lon-boton");
  const downloadButton = document.getElementById("descargar-puntos");

  let { source, vector } = crearCapaPuntos();
  map.addLayer(vector);

  function rebuildPuntoLayer() {
    const newLayer = crearCapaPuntos();
    source = newLayer.source;
    vector = newLayer.vector;

    map.addLayer(vector);
    vector.setVisible(true);

    return { newSource: source, newVector: vector };
  }

  const puntoControl = new Punto({
    onActivate,
    onRebuildLayer: rebuildPuntoLayer,
    source,
    vector,
  });

  searchButton.addEventListener("click", () => {
    if (!vector.getVisible()) {
      map.removeLayer(vector);

      const newLayer = crearCapaPuntos();
      source = newLayer.source;
      vector = newLayer.vector;

      map.addLayer(vector);
      vector.setVisible(true);

      puntoControl.vectorSource = source;
      puntoControl.vector = vector;
    }

    const lat = parseFloat(latInput.value);
    const lon = parseFloat(lonInput.value);

    if (!isNaN(lat) && !isNaN(lon)) {
      const coordinate = fromLonLat([lon, lat]);
      map.getView().animate({
        center: coordinate,
        zoom: 18,
        duration: 500,
      });

      source.addFeature(
        new Feature({
          geometry: new Point(coordinate),
        })
      );

      capaActiva(vector, vector.getSource().getExtent(), getUid(vector));
    } else {
      alert("coordenadas invalidas");
    }
  });

  downloadButton.addEventListener("click", function () {
    descargarCapa(source);
  });

  map.addControl(puntoControl);
}
